import React from 'react'
import { cn } from '#app/shared/lib/misc.js'
import Footer from './Footer'
import WhatsAppFloatingButton from './WhatsAppFloatingButton'

type Props = {
  children: React.ReactNode
  className?: string
  isFixed?: boolean
}

export default function MainLayout({ children, className, isFixed }: Props) {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-25">
      <div className={cn('flex-grow', className)}>{children}</div>
      <Footer isFixed={isFixed} />
      <WhatsAppFloatingButton />
    </div>
  )
}
